module.exports = __webpack_public_path__ + "site/img/26.5cf43bb8.jpg";